<template>
  <div class="page">
    <div class="page-bg">
      <img class="logo" src="../assets/images/logo.png" alt="">
      <div class="h1">拼词之星</div>
      <div class="h2">SPELLING STAR</div>
      <div class="h3">请使用拼词之星APP扫码开通</div>
      <!-- <canvas ref="qrCanvas" class="qrcode"></canvas> -->
       <template v-if="model === 'unknown'">
        <div class="btn btn2 btn3" @click="openApp('ios')">打开拼词之星(iOS)</div>
        <div class="btn btn2 btn3" @click="openApp('android')">打开拼词之星(Android)</div>
       </template>
      <div v-else class="btn" @click="openApp(model)">打开拼词之星</div>
    </div>
    <div class="mask" v-if="showMask">
      <img class="arrow" src="../assets/images/arrow.png" alt="">
      <div class="tip">请在浏览器中打开此链接</div>
    </div>
  </div>
</template>
 
<script>
import QRCode from 'qrcode'
 
export default {
  data () {
    return {
      androidDownloadUrl: '',
      showMask: false,
      model: ''
    }
  },
  mounted() {
    // let code = this.$route.query.no
    // console.log(code)
    // this.generateQRCode(code)
    this.getAppInfo()
  },
  methods: {
    generateQRCode(code) {
      const canvas = this.$refs.qrCanvas
      QRCode.toCanvas(canvas, code, { margin: 1.2 }, error => {
        if (error) console.error(error)
      })
    },
    getAppInfo () {
      this.$http.get('/config/ajax_app_info').then(res => {
        if (res.code === 200) {
          this.androidDownloadUrl = res.data.android_url
          const userAgent = navigator.userAgent;

          this.model = /iPhone|iPod|iPad/i.test(userAgent) ? 'ios' : /android/i.test(userAgent) ? 'android' : 'unknown'
        }
      })
    },
    openApp(type) {
      //是否是微信浏览器
      if (/(micromessenger)/i.test(navigator.userAgent)) { 
      //是否电脑微信或者微信开发者工具
        if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
          console.log('电脑微信或者微信开发者工具')
        }else{
          //手机微信打开的浏览器
          console.log('手机微信')
          this.showMask = true
        }
      } else {
        console.log('其他浏览器')
        const CONFIG = {
          iosScheme: "pczx://pages/tabbar/home/index", // iOS 应用 URL
          iosDownload: "https://apps.apple.com/cn/app/%E6%8B%BC%E8%AF%8D%E4%B9%8B%E6%98%9F/id6504004311", // iOS 下载页面 URL
          androidScheme: "pczx://pages/tabbar/home/index", // Android 应用 URL
          androidDownload: this.androidDownloadUrl, //Android 下载页面 URL
        };
        const userAgent = navigator.userAgent;
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 确保 iframe 不会显示在页面上
        // const startTime = new Date().getTime();
        this.hasApp = true; // 假设设备上已安装应用
        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁止背景点击
          message: '请稍后...'
        })
        if (/iPhone|iPod|iPad/i.test(userAgent) || type === 'ios') {
          this.timer = setTimeout(() => {
            // const endTime = new Date().getTime();
            // if (endTime - startTime < 2000) {
              this.hasApp = false;
              window.location.href = CONFIG.iosDownload; // 跳转到 iOS 下载页面的 URL
            // }
            document.body.removeChild(iframe);
          }, 3000);
          iframe.src = CONFIG.iosScheme; // 尝试打开 iOS 应用的 URL
          window.location.href = CONFIG.iosScheme
        } else if (/android/i.test(userAgent) || type === 'android') {
          this.timer = setTimeout(() => {
            // const endTime = new Date().getTime();
            // if (endTime - startTime < 2000) {
              this.hasApp = false;
              window.location.href = CONFIG.androidDownload; // 跳转到 Android 下载页面的 URL
            // }
            document.body.removeChild(iframe);
          }, 3000);
          iframe.src = CONFIG.androidScheme; // 尝试打开 Android 应用的 URL
          window.location.href = CONFIG.androidScheme
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle, #373632, #140e01);
  overflow-x: hidden;
  overflow-y: auto;
}
.page-bg{
  width: 100%;
  height: 100vh;
  background-image: url(../assets/images/share/diwen.png);
  background-size: 100% auto;
  background-position: center;
  background-repeat: repeat-y;
  padding-top: 80px;
  box-sizing: border-box;
  font-family: hzgb;
  color: #fff;
  text-align: center;
}
.qrcode{
  width: 300px !important;
  height: 300px !important;
  margin: 40px 0;
}
.h1{
  font-size: 28px;
  margin: 30px 0 10px;
}
.h2{
  font-size: 18px;
}
.h3{
  font-size: 18px;
  margin-top: 80px;
}
.btn{
  background: linear-gradient(to bottom, #ffd16b, #fff497);
  box-shadow: 0 6px 0 0 #d9b059;
  width: 200px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  font-size: 16px;
  font-family: normal;
  color: #000;
  font-weight: 900;
  margin: 20px auto 0;
}
.mask{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.75);
  z-index: 10000;
  font-size: 16px;
  .arrow{
    position: absolute;
    right: 30px;
    top: 10px;
    width: 100px;
  }
  .tip{
    color: #c89d41;
    font-size: 18px;
    text-align: center;
    width: 60%;
    height: 60px;
    line-height: 60px;
    background-color: #fff;
    border-radius: 15px;
    position: absolute;
    top: 55px;
    left: 30px;
  }
}
</style>